import React from 'react'

const Tech = () => {
  return (
    <div className="tech-page-container">
      <h1>developer.</h1>
    </div>
  )
}
export default Tech